import React, { useState, useEffect } from 'react';
import { ShieldCheck, Mail, Lock, LogIn, Eye, EyeOff, AlertCircle } from 'lucide-react';
import { login, getSettings } from '../../../shared/api/authApi';
import { Footer } from '../../../shared/components';
import { resolveAssetUrl } from '../../../shared/utils/branding';
import '../../../styles/features/auth/Login.css';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [branding, setBranding] = useState({ logoUrl: '', title: '', tagline: '' });

  useEffect(() => {
    getSettings()
      .then(({ data }) => setBranding({ logoUrl: data?.logoUrl || '', title: data?.title || '', tagline: data?.tagline || '' }))
      .catch(() => {});
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await login({ email, password });
      localStorage.setItem('token', response.data.token);
      onLogin(response.data.token);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          {branding.logoUrl
            ? <img className="login-logo__img" src={resolveAssetUrl(branding.logoUrl)} alt={branding.title || 'Logo'} />
            : <ShieldCheck size={32} className="login-logo__icon" />}
        </div>
        <h1>{branding.title ? `${branding.title}` : 'Admin Login'}</h1>
        <p className="subtitle">{branding.tagline || 'Sign in to manage your status page'}</p>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="error-message">
              <AlertCircle size={15} />
              <span>{error}</span>
            </div>
          )}

          <div className="form-group">
            <label><Mail size={12} /> Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              autoComplete="username"
              autoFocus
              required
            />
          </div>

          <div className="form-group">
            <label><Lock size={12} /> Password</label>
            <div className="login-password">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="login-password__toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                tabIndex={-1}
              >
                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Signing in…' : <><LogIn size={15} /> Sign In</>}
          </button>
        </form>

        <div className="login-footer">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Login;
